import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, vModelText as _vModelText, withDirectives as _withDirectives, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, createBlock as _createBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-d17bcbc0"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "ui-page" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "titlebar" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "titlebar-content" }, [
    /*#__PURE__*/_createElementVNode("div", { class: "titlebar-title --mobile" }, [
      /*#__PURE__*/_createElementVNode("h2", { class: "titlebar-text" }, "Pedidos")
    ])
  ])
], -1))
const _hoisted_3 = { class: "ui-card ui-mb-20" }
const _hoisted_4 = { class: "ui-card-body" }
const _hoisted_5 = { class: "ant-row ui-mb-20" }
const _hoisted_6 = { class: "ant-row" }
const _hoisted_7 = { class: "ui-card" }
const _hoisted_8 = { class: "ui-card-body" }
const _hoisted_9 = { class: "ant-row ui-mb-20" }
const _hoisted_10 = { class: "ant-col ant-col-xs-24 ant-col-xl-16" }
const _hoisted_11 = { class: "ant-input-affix-wrapper" }
const _hoisted_12 = { class: "ant-input-prefix" }
const _hoisted_13 = {
  role: "img",
  "aria-label": "user",
  type: "user",
  class: "anticon anticon-user"
}
const _hoisted_14 = { class: "ant-col ant-col-xs-24 ant-col-xl-6" }
const _hoisted_15 = { class: "ant-input-group-wrapper" }
const _hoisted_16 = { class: "ant-input-wrapper ant-input-group" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "ant-input-group-addon ui-fw-500" }, "Ordenar", -1))
const _hoisted_18 = { class: "ant-col ant-col-xs-24 ant-col-xl-2" }
const _hoisted_19 = { class: "ui-table" }
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ant-row ui-row header" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "ant-col ant-col-xs-24 ant-col-xl-4 ui-cell ui-align-center" }, " Pedido "),
  /*#__PURE__*/_createElementVNode("div", { class: "ant-col ant-col-xs-24 ant-col-xl-4 ui-cell" }, " Data "),
  /*#__PURE__*/_createElementVNode("div", { class: "ant-col ant-col-xs-24 ant-col-xl-7 ui-cell" }, " Cliente "),
  /*#__PURE__*/_createElementVNode("div", { class: "ant-col ant-col-xs-24 ant-col-xl-4 ui-cell" }, " Valor Total "),
  /*#__PURE__*/_createElementVNode("div", { class: "ant-col ant-col-xs-24 ant-col-xl-1 ui-cell ui-align-center" }, " Status "),
  /*#__PURE__*/_createElementVNode("div", { class: "ant-col ant-col-xs-24 ant-col-xl-4 ui-cell ui-align-center" }, " Ações ")
], -1))
const _hoisted_21 = { class: "ui-rows ui-rolagem-padrao" }
const _hoisted_22 = {
  class: "ant-col ant-col-xs-24 ant-col-xl-4 ui-cell ui-ellipsis ui-align-center",
  "data-title": "Pedido"
}
const _hoisted_23 = {
  class: "ant-col ant-col-xs-24 ant-col-xl-4 ui-cell ui-ellipsis",
  "data-title": "Data"
}
const _hoisted_24 = {
  class: "ant-col ant-col-xs-24 ant-col-xl-7 ui-cell ui-ellipsis",
  "data-title": "Cliente"
}
const _hoisted_25 = {
  class: "ant-col ant-col-xs-24 ant-col-xl-4 ui-cell ui-ellipsis",
  "data-title": "Valor Total"
}
const _hoisted_26 = {
  class: "ant-col ant-col-xs-24 ant-col-xl-1 ui-cell ui-align-center",
  "data-title": "Status"
}
const _hoisted_27 = { style: {"display":"inline-flex","gap":"10px"} }
const _hoisted_28 = {
  class: "ant-col ant-col-xs-24 ant-col-xl-4 ui-cell ui-align-center",
  "data-title": "Ações"
}
const _hoisted_29 = { class: "ui-actions" }
const _hoisted_30 = { class: "ant-row" }
const _hoisted_31 = { class: "ant-col ant-col-xs-24 ant-col-xl-24" }
const _hoisted_32 = { class: "ant-row" }
const _hoisted_33 = { class: "ant-col ant-col-xs-24 ant-col-xl-10" }
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ui-button-content" }, " Aplicar ", -1))
const _hoisted_35 = [
  _hoisted_34
]
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ant-col ant-col-xs-24 ant-col-xl-4" }, null, -1))
const _hoisted_37 = { class: "ant-col ant-col-xs-24 ant-col-xl-10" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_affix = _resolveComponent("a-affix")!
  const _component_totalizador_decorado = _resolveComponent("totalizador-decorado")!
  const _component_icone = _resolveComponent("icone")!
  const _component_a_select = _resolveComponent("a-select")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_a_tooltip = _resolveComponent("a-tooltip")!
  const _component_a_pagination = _resolveComponent("a-pagination")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_a_result = _resolveComponent("a-result")!
  const _component_a_skeleton = _resolveComponent("a-skeleton")!
  const _component_combo_status_pedido = _resolveComponent("combo-status-pedido")!
  const _component_a_collapse_panel = _resolveComponent("a-collapse-panel")!
  const _component_a_collapse = _resolveComponent("a-collapse")!
  const _component_a_drawer = _resolveComponent("a-drawer")!
  const _component_comunicacao_api = _resolveComponent("comunicacao-api")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_a_affix, { "offset-top": 50 }, {
      default: _withCtx(() => [
        _hoisted_2
      ]),
      _: 1
    }),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", {
            class: "ant-col ant-col-xs-24 ant-col-xl-6 ui-filtros-totalizador",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.buscarPedidosPorStatus(_ctx.EStatusPedido.PedidoEfetuado)))
          }, [
            _createVNode(_component_totalizador_decorado, {
              titulo: "EFETUADOS",
              cor: _ctx.obterCorStatus(_ctx.EStatusPedido.PedidoEfetuado),
              iconeColorido: false,
              valor: _ctx.obterTotal(_ctx.EStatusPedido.PedidoEfetuado),
              monetario: true
            }, null, 8, ["cor", "valor"])
          ]),
          _createElementVNode("div", {
            class: "ant-col ant-col-xs-24 ant-col-xl-6 ui-filtros-totalizador",
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.buscarPedidosPorStatus(_ctx.EStatusPedido.AguardandoPagamento)))
          }, [
            _createVNode(_component_totalizador_decorado, {
              titulo: "AGUARDANDO PAGAMENTO",
              cor: _ctx.obterCorStatus(_ctx.EStatusPedido.AguardandoPagamento),
              iconeColorido: false,
              valor: _ctx.obterTotal(_ctx.EStatusPedido.AguardandoPagamento),
              monetario: true
            }, null, 8, ["cor", "valor"])
          ]),
          _createElementVNode("div", {
            class: "ant-col ant-col-xs-24 ant-col-xl-6 ui-filtros-totalizador",
            onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.buscarPedidosPorStatus(_ctx.EStatusPedido.EmPreparacao)))
          }, [
            _createVNode(_component_totalizador_decorado, {
              titulo: "EM SEPARAÇÃO",
              cor: _ctx.obterCorStatus(_ctx.EStatusPedido.EmPreparacao),
              iconeColorido: false,
              valor: _ctx.obterTotal(_ctx.EStatusPedido.EmPreparacao),
              monetario: true
            }, null, 8, ["cor", "valor"])
          ]),
          _createElementVNode("div", {
            class: "ant-col ant-col-xs-24 ant-col-xl-6 ui-filtros-totalizador",
            onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.buscarPedidosPorStatus(_ctx.EStatusPedido.AguardandoRetirada)))
          }, [
            _createVNode(_component_totalizador_decorado, {
              titulo: "AGUARDANDO RETIRADA",
              cor: _ctx.obterCorStatus(_ctx.EStatusPedido.AguardandoRetirada),
              iconeColorido: false,
              valor: _ctx.obterTotal(_ctx.EStatusPedido.AguardandoRetirada),
              monetario: true
            }, null, 8, ["cor", "valor"])
          ])
        ]),
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("div", {
            class: "ant-col ant-col-xs-24 ant-col-xl-6 ui-filtros-totalizador",
            onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.buscarPedidosPorStatus(_ctx.EStatusPedido.Entregue)))
          }, [
            _createVNode(_component_totalizador_decorado, {
              titulo: "ENTREGUES",
              cor: _ctx.obterCorStatus(_ctx.EStatusPedido.Entregue),
              iconeColorido: false,
              valor: _ctx.obterTotal(_ctx.EStatusPedido.Entregue),
              monetario: true
            }, null, 8, ["cor", "valor"])
          ]),
          _createElementVNode("div", {
            class: "ant-col ant-col-xs-24 ant-col-xl-6 ui-filtros-totalizador",
            onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.buscarPedidosPorStatus(_ctx.EStatusPedido.EmTransito)))
          }, [
            _createVNode(_component_totalizador_decorado, {
              titulo: "EM TRÂNSITO",
              cor: _ctx.obterCorStatus(_ctx.EStatusPedido.EmTransito),
              iconeColorido: false,
              valor: _ctx.obterTotal(_ctx.EStatusPedido.EmTransito),
              monetario: true
            }, null, 8, ["cor", "valor"])
          ]),
          _createElementVNode("div", {
            class: "ant-col ant-col-xs-24 ant-col-xl-6 ui-filtros-totalizador",
            onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.buscarPedidosPorStatus(_ctx.EStatusPedido.EmRotaDeEntrega)))
          }, [
            _createVNode(_component_totalizador_decorado, {
              titulo: "EM ROTA DE ENTREGA",
              cor: _ctx.obterCorStatus(_ctx.EStatusPedido.EmRotaDeEntrega),
              iconeColorido: false,
              valor: _ctx.obterTotal(_ctx.EStatusPedido.EmRotaDeEntrega),
              monetario: true
            }, null, 8, ["cor", "valor"])
          ]),
          _createElementVNode("div", {
            class: "ant-col ant-col-xs-24 ant-col-xl-6 ui-filtros-totalizador",
            onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.buscarPedidosPorStatus(_ctx.EStatusPedido.Cancelado)))
          }, [
            _createVNode(_component_totalizador_decorado, {
              titulo: "CANCELADOS",
              cor: _ctx.obterCorStatus(_ctx.EStatusPedido.Cancelado),
              iconeColorido: false,
              valor: _ctx.obterTotal(_ctx.EStatusPedido.Cancelado),
              monetario: true
            }, null, 8, ["cor", "valor"])
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_7, [
      _createElementVNode("div", _hoisted_8, [
        _createElementVNode("div", _hoisted_9, [
          _createElementVNode("div", _hoisted_10, [
            _createElementVNode("span", _hoisted_11, [
              _createElementVNode("span", _hoisted_12, [
                _createElementVNode("span", _hoisted_13, [
                  _createVNode(_component_icone, { nome: "pesquisar" })
                ])
              ]),
              _withDirectives(_createElementVNode("input", {
                placeholder: "Buscar por número do pedido, cliente, cpf/cnpj, valor total ou forma de entrega e pagamento",
                type: "text",
                class: "ant-input",
                "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.state.parametrosConsulta.valorPesquisa) = $event)),
                onInput: _cache[9] || (_cache[9] = ($event: any) => (_ctx.buscarPedidoPorNome()))
              }, null, 544), [
                [_vModelText, _ctx.state.parametrosConsulta.valorPesquisa]
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_14, [
            _createElementVNode("span", _hoisted_15, [
              _createElementVNode("span", _hoisted_16, [
                _hoisted_17,
                _createVNode(_component_a_select, {
                  class: "ui-full",
                  value: _ctx.state.ordenarPor,
                  "onUpdate:value": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.state.ordenarPor) = $event)),
                  "show-search": "",
                  placeholder: "Ordenar por",
                  options: _ctx.state.opcoesOrdenacao,
                  onChange: _cache[11] || (_cache[11] = ($event: any) => (_ctx.buscarDados()))
                }, null, 8, ["value", "options"])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_18, [
            _createElementVNode("button", {
              class: "ui-button -second ui-mh-32 ui-full",
              onClick: _cache[12] || (_cache[12] = ($event: any) => (_ctx.state.apresentarFiltros =!_ctx.state.apresentarFiltros))
            }, [
              _createVNode(_component_icone, {
                class: "ui-mr-5",
                nome: "filtro"
              }),
              _createTextVNode(" Filtros ")
            ])
          ])
        ]),
        _createVNode(_component_a_skeleton, {
          loading: _ctx.appBase.carregando
        }, {
          default: _withCtx(() => [
            ((_ctx.state.pedidos.length > 0))
              ? (_openBlock(), _createBlock(_component_a_form, {
                  key: 0,
                  layout: "vertical"
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_19, [
                      _hoisted_20,
                      _createElementVNode("div", _hoisted_21, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.state.pedidos, (pedido) => {
                          return (_openBlock(), _createElementBlock("div", {
                            key: pedido.codigo,
                            class: "ant-row ui-row"
                          }, [
                            _createElementVNode("div", _hoisted_22, [
                              _createVNode(_component_router_link, {
                                title: pedido.numeroIdentificacao,
                                class: "ui-link",
                                to: { name: 'PedidoDetalheEditar', params: { numeroIdentificacao:pedido.numeroIdentificacao }}
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(pedido.numeroIdentificacao), 1)
                                ]),
                                _: 2
                              }, 1032, ["title", "to"])
                            ]),
                            _createElementVNode("div", _hoisted_23, _toDisplayString(_ctx.UtilitarioData.aplicaFormatoDataHoraMinuto(pedido.data)), 1),
                            _createElementVNode("div", _hoisted_24, [
                              _createVNode(_component_router_link, {
                                title: 'CPF/CNPJ: ' + pedido.cpfCnpj,
                                class: "ui-link",
                                to: { name: 'PedidoDetalheEditar', params: { numeroIdentificacao:pedido.numeroIdentificacao }}
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(pedido.cliente), 1)
                                ]),
                                _: 2
                              }, 1032, ["title", "to"])
                            ]),
                            _createElementVNode("div", _hoisted_25, " R$ " + _toDisplayString(_ctx.UtilitarioMascara.mascararValor(pedido.valorTotal)), 1),
                            _createElementVNode("div", _hoisted_26, [
                              _createVNode(_component_a_tooltip, {
                                placement: "top",
                                title: _ctx.obterDescricaoStatus(pedido.status)
                              }, {
                                default: _withCtx(() => [
                                  _createElementVNode("div", _hoisted_27, [
                                    _createElementVNode("span", {
                                      style: _normalizeStyle('margin-left: 10px;border-radius: 45px;height: 20px; width: 20px;background-color:' + _ctx.obterCorStatus(pedido.status) + ';')
                                    }, null, 4)
                                  ])
                                ]),
                                _: 2
                              }, 1032, ["title"])
                            ]),
                            _createElementVNode("div", _hoisted_28, [
                              _createElementVNode("div", _hoisted_29, [
                                _createVNode(_component_a_tooltip, { title: "Detalhes" }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_router_link, {
                                      class: "ui-action",
                                      to: { name: 'PedidoDetalheEditar', params: { numeroIdentificacao:pedido.numeroIdentificacao }}
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_icone, { nome: "editar" })
                                      ]),
                                      _: 2
                                    }, 1032, ["to"])
                                  ]),
                                  _: 2
                                }, 1024)
                              ])
                            ])
                          ]))
                        }), 128))
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_30, [
                      _createElementVNode("div", _hoisted_31, [
                        _createVNode(_component_a_pagination, {
                          class: "ui-pagination",
                          current: _ctx.appBase.paginacao.paginaAtual,
                          "onUpdate:current": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.appBase.paginacao.paginaAtual) = $event)),
                          size: "small",
                          total: _ctx.appBase.paginacao.totalRegistros,
                          "show-total": (total, range) => `${_ctx.UtilitarioMascara.mascararNumeroInteiro(range[0])} - ${_ctx.UtilitarioMascara.mascararNumeroInteiro(range[1])} de ${_ctx.UtilitarioMascara.mascararNumeroInteiro(total)} pedidos`,
                          "page-size": _ctx.appBase.paginacao.qtdeRegistrosPagina,
                          "show-size-changer": "",
                          onShowSizeChange: _ctx.qtdeRegistrosPaginaAlterada,
                          onChange: _ctx.paginacaAlterada
                        }, null, 8, ["current", "total", "show-total", "page-size", "onShowSizeChange", "onChange"])
                      ])
                    ])
                  ]),
                  _: 1
                }))
              : (_openBlock(), _createBlock(_component_a_result, {
                  key: 1,
                  status: "404",
                  title: "Nenhum pedido encontrado",
                  "sub-title": "Verifique os seus filtros."
                }))
          ]),
          _: 1
        }, 8, ["loading"])
      ])
    ]),
    _createVNode(_component_a_drawer, {
      visible: _ctx.state.apresentarFiltros,
      "onUpdate:visible": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.state.apresentarFiltros) = $event)),
      class: "custom-class",
      style: {"color":"red"},
      title: "Filtros",
      placement: "right"
    }, {
      footer: _withCtx(() => [
        _createElementVNode("div", _hoisted_32, [
          _createElementVNode("div", _hoisted_33, [
            _createElementVNode("button", {
              class: "ui-button -primary ui-full",
              onClick: _cache[15] || (_cache[15] = ($event: any) => (_ctx.buscarDados()))
            }, _hoisted_35)
          ]),
          _hoisted_36,
          _createElementVNode("div", _hoisted_37, [
            _createElementVNode("button", {
              class: "ui-button -second ui-full",
              onClick: _cache[16] || (_cache[16] = ($event: any) => (_ctx.limparFiltros()))
            }, " Limpar filtros ")
          ])
        ])
      ]),
      default: _withCtx(() => [
        _createVNode(_component_a_collapse, null, {
          default: _withCtx(() => [
            _createVNode(_component_a_collapse_panel, {
              key: "1",
              header: "Status"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_combo_status_pedido, {
                  valor: _ctx.state.parametrosConsulta.status,
                  "onUpdate:valor": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.state.parametrosConsulta.status) = $event))
                }, null, 8, ["valor"])
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["visible"]),
    _createVNode(_component_comunicacao_api, {
      visivel: _ctx.appBase.exibirComunicaoApi,
      "onUpdate:visivel": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.appBase.exibirComunicaoApi) = $event)),
      apresentarBarraProgresso: _ctx.appBase.apresentarBarraProgresso,
      fraseBarraProgresso: _ctx.appBase.fraseBarraProgresso,
      resposta: _ctx.appBase.resposta
    }, null, 8, ["visivel", "apresentarBarraProgresso", "fraseBarraProgresso", "resposta"])
  ]))
}